import {AxiosResponse} from "axios";
import request from "./base.service";

function getUserInfo(): Promise<AxiosResponse<any>> {
  return request.build().get("/api/v1/fs/users/profile");
}

function getHealthInfo(): Promise<AxiosResponse<any>> {
  return request.build().get("/api/v1/hcs/persons/health");
}

function getVaccuationSelf(): Promise<AxiosResponse<any>> {
  return request.build().get("/api/v1/hcs/vaccinations/self");
}

function scanVaccuationInfoByQrCode(qrCode: any): Promise<AxiosResponse<any>> {
  return request.build().get(`/public/v1/hcs/vaccinations/qr-code/${qrCode}`);
}

function scanHealthUserInfoByQrCode(qrCode: any): Promise<AxiosResponse<any>> {
  return request
    .build()
    .get(`/api/v1/hcs/persons/health/status/qr-code/${qrCode}`);
}

function persistEmail(formData: any): Promise<AxiosResponse<any>> {
  return request
    .withHeaders({"Content-Type": "application/json;utf-8"})
    .build()
    .patch("/api/v1/fs/users/profile", formData);
}

function profile(formData: any): Promise<AxiosResponse<any>> {
  return request
    .withHeaders({"Content-Type": "application/json;utf-8"})
    .build()
    .patch("/api/v1/fs/users/profile", formData);
}

function contactUs(formData: any): Promise<AxiosResponse<any>> {
  return request
    .withHeaders({"Content-Type": "application/json;utf-8"})
    .build()
    .post("/api/v1/support/contact-us", formData);
}

function savePassport(formData: any): Promise<AxiosResponse<any>> {
  return request
    .withHeaders({"Content-Type": "application/json;utf-8"})
    .build()
    .post("/api/v1/fs/users/passport", formData);
}

// eslint-disable-next-line
export default {
  getUserInfo,
  getHealthInfo,
  scanHealthUserInfoByQrCode,
  persistEmail,
  profile,
  getVaccuationSelf,
  scanVaccuationInfoByQrCode,
  contactUs,
  savePassport
};
